import Script from 'next/script';
import type { IHubSpot } from './MarketingScripts.types';

export const HubSpot = ({ hubspotId }: IHubSpot) => {
  return (
    <Script
      id="hs-script-loader"
      strategy="afterInteractive"
      src={`https://js.hs-scripts.com/${hubspotId}.js`}
      async
      defer
    />
  );
};
